import { Box, Link, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { CustomerContactPerson } from "../customersApi";
import type { LocatedCustomer } from "./locatedCustomer";

interface Props {
  readonly customer: LocatedCustomer;
}

const CustomerMapDetails: FC<Props> = ({ customer }) => (
  <Stack spacing={1} sx={{ minWidth: 220 }}>
    <Typography variant="body2">Opiekun: {customer.accountManager?.name ?? "brak"}</Typography>
    <Typography variant="body2">Status: {customer.status}</Typography>
    {customer.contacts.length > 0 && (
      <>
        <Typography variant="subtitle2">Osoby kontaktowe</Typography>
        {customer.contacts.map((contact, index) => (
          <Box key={`${contact.loginEmail ?? contact.email ?? contact.name}-${index}`}>
            <Typography variant="body2">{contactLabel(contact)}</Typography>
            {contact.phone && (
              <Typography variant="body2">
                <Link href={`tel:${contact.phone}`}>{contact.phone}</Link>
              </Typography>
            )}
            {contact.email && (
              <Typography variant="body2">
                <Link href={`mailto:${contact.email}`}>{contact.email}</Link>
              </Typography>
            )}
          </Box>
        ))}
      </>
    )}
  </Stack>
);

function contactLabel(contact: CustomerContactPerson): string {
  const name = contact.name ?? contact.loginEmail ?? "";
  return contact.position ? `${name} (${contact.position})` : name;
}

export default CustomerMapDetails;
